import { useTranslation } from 'react-i18next';
import { Building2 } from 'lucide-react';
import { useWorkspace } from '@/workspace/WorkspaceContext';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { MembersTab } from '@/components/organization/MembersTab';
import { BotsTab } from '@/components/organization/BotsTab';
import { ApiKeysTab } from '@/components/organization/ApiKeysTab';

export function Organization(): JSX.Element {
  const { t } = useTranslation();
  const { currentOrgId, currentOrg } = useWorkspace();

  if (!currentOrgId) {
    return (
      <div className="rounded-md border border-dashed p-8 text-center text-sm text-muted-foreground">
        {t('organizationPage.empty')}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="flex items-center gap-3">
        <Building2 className="h-6 w-6 text-primary" />
        <div>
          <h1 className="text-2xl font-semibold">{currentOrg?.name ?? '—'}</h1>
          <p className="font-mono text-xs text-muted-foreground">{currentOrgId}</p>
        </div>
        {currentOrg ? (
          <Badge variant="secondary" className="ml-auto uppercase">
            {currentOrg.role}
          </Badge>
        ) : null}
      </header>

      <Tabs defaultValue="members" className="w-full">
        <TabsList>
          <TabsTrigger value="members">{t('organization.tabs.members')}</TabsTrigger>
          <TabsTrigger value="bots">{t('organization.tabs.bots')}</TabsTrigger>
          <TabsTrigger value="api-keys">{t('organization.tabs.apiKeys')}</TabsTrigger>
        </TabsList>

        <TabsContent value="members" className="mt-4">
          <MembersTab />
        </TabsContent>
        <TabsContent value="bots" className="mt-4">
          <BotsTab />
        </TabsContent>
        <TabsContent value="api-keys" className="mt-4">
          <ApiKeysTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
